import { ReactComponent as ArrowRight } from "../../../assets/images/icon/arrow-right.svg"
import { ReactComponent as ArrowDown } from "../../../assets/images/icon/arrow-down.svg"
import { ReactComponent as ArrowDownV2 } from "../../../assets/images/icon/arrowDownV2.svg"
interface IProps {
    type?: "default" | "underline";
    icon?: boolean;
    styles?: { container?: React.CSSProperties, icon?: React.CSSProperties, children?: React.CSSProperties }
    classNames?: { container?: string, icon?: string, children?: string }
    style?: React.CSSProperties;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    textDecorationColor?: string;
    rightIcon?: 'arrowRight' | 'arrowDown';
}

const TextBtn = ({ type, icon = true, rightIcon, style, children, onClick, textDecorationColor, styles, classNames }: IProps) => {
    const getStyleByType = () => {
        if (type === 'underline') {
            return {
                textDecoration: 'underline',
                textDecorationColor: textDecorationColor ?? 'var(--secondarys600)',
                textUnderlineOffset: '3px',
            }
        }
    }
    const getRightIcon = (rightIcon?: string) => {
        switch (rightIcon) {
            case 'arrowRight':
                return <ArrowRight width={16} height={16} stroke={'#737373'} style={styles?.icon} className={(classNames?.container ?? '')} />;
            case 'arrowDown':
                return <ArrowDownV2 width={16} height={16} stroke={'#737373'} style={styles?.icon} className={(classNames?.container ?? '')} />;
            default:
                return <ArrowRight width={16} height={16} stroke={'#737373'} style={styles?.icon} className={(classNames?.container ?? '')} />;
        }
    }

    return <>
        <div className={"btn/text-btn secondary/s600"} style={{
            display: 'inline-block',
            cursor: 'pointer',
            ...style
        }}
            onClick={(e) => onClick && onClick(e)}
        >
            <div className={(classNames?.container ?? '')} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 'var(--space4)', padding: 'var(--space4) 1px var(--space4) var(--space4)', ...styles?.container }}>
                <div className={classNames?.children ?? ''} style={{ ...getStyleByType(), ...styles?.children }}>{children}</div>
                {icon && getRightIcon(rightIcon)}
            </div>
        </div>
    </>
}

export { TextBtn };